import type { Testkit, UniDriver } from 'ricos-types/testkit';
import { dataHook } from 'wix-rich-content-common';

export type BulletListTestkit = Testkit<{
  content: {
    atIndex: (index: number) => {
      getStyles: () => Promise<CSSStyleDeclaration | null>;
    };
  };
  toolbars: {
    createTextButtonToolbars: (getTextButtonBase: () => UniDriver<Element>) => {
      click: () => Promise<void>;
    };
  };
}>;

export const createBulletListTestkit: BulletListTestkit = getBase => {
  return {
    content: {
      atIndex: index => {
        return {
          getStyles: async () => {
            const el = (await getBase().getAll('li')).at(index);
            const style = (await el._prop('style')) as CSSStyleDeclaration;
            return style;
          },
        };
      },
    },
    toolbars: {
      createTextButtonToolbars: (getTextButtonBase: () => UniDriver<Element>) => ({
        click: async () => {
          (await getTextButtonBase().get(dataHook('textBlockStyleButton_Bulletedlist'))).click();
        },
      }),
    },
  };
};
